import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import { stadtteile, ratgeber } from '../data/stadtteile';

const SitemapHTML = () => {
  return (
    <>
      <Helmet>
        <title>Sitemap – Schlüsseldienst.services</title>
        <meta name="description" content="Übersicht aller Seiten unserer Website" />
        <link rel="canonical" href="https://schluesseldienst.services/sitemap.html" />
      </Helmet>
      
      <div className="container mx-auto px-4 py-12">
        <Breadcrumbs items={[{ label: 'Sitemap' }]} />
        
        <h1 className="text-4xl sm:text-5xl font-bold mb-8">Sitemap</h1>
        
        <div className="max-w-4xl">
          <div className="bg-orange-50 border-l-4 border-orange-600 p-6 mb-8">
            <p className="text-lg">
              Hier finden Sie eine Übersicht aller Seiten unserer Website für einen schnellen Zugriff.
            </p>
          </div>

          {/* Hauptseiten */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-6">Hauptseiten</h2>
            <ul className="space-y-3">
              <li>
                <Link to="/schluesseldienst-dortmund" className="text-orange-600 hover:underline text-lg">
                  → Startseite – Schlüsseldienst Dortmund
                </Link>
              </li>
              <li>
                <Link to="/preise" className="text-orange-600 hover:underline text-lg">
                  → Preise & Leistungen
                </Link>
              </li>
              <li>
                <Link to="/einsatzgebiete" className="text-orange-600 hover:underline text-lg">
                  → Einsatzgebiete Übersicht
                </Link>
              </li>
              <li>
                <Link to="/ratgeber" className="text-orange-600 hover:underline text-lg">
                  → Ratgeber Übersicht
                </Link>
              </li>
            </ul>
          </section>

          {/* Stadtteile */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-6">Stadtteile in Dortmund ({stadtteile.length})</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {stadtteile.sort((a, b) => a.name.localeCompare(b.name)).map((st) => (
                <Link
                  key={st.slug}
                  to={`/schluesseldienst-dortmund-${st.slug}`}
                  className="bg-white hover:bg-orange-50 p-3 rounded border border-gray-200 hover:border-orange-300 transition-colors"
                >
                  <div className="font-semibold">{st.name}</div>
                  <div className="text-sm text-gray-600">PLZ: {st.plz.join(', ')}</div>
                </Link>
              ))}
            </div>
          </section>

          {/* Ratgeber */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-6">Ratgeber-Artikel ({ratgeber.length})</h2>
            <ul className="space-y-3">
              {ratgeber.map((article) => (
                <li key={article.slug}>
                  <Link 
                    to={`/ratgeber/${article.slug}`} 
                    className="text-orange-600 hover:underline"
                  >
                    → {article.title}
                  </Link>
                  <p className="text-sm text-gray-600 ml-4 mt-1">{article.excerpt}</p>
                </li>
              ))}
            </ul>
          </section>

          {/* Rechtliches */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold mb-6">Rechtliches & Informationen</h2>
            <ul className="space-y-3">
              <li>
                <Link to="/impressum" className="text-orange-600 hover:underline text-lg">
                  → Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" className="text-orange-600 hover:underline text-lg">
                  → Datenschutzerklärung
                </Link>
              </li>
            </ul>
          </section>

          {/* CTA */}
          <div className="bg-gradient-to-br from-orange-600 to-amber-500 text-white rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">Brauchen Sie sofort Hilfe?</h2>
            <p className="mb-6">Rufen Sie uns jederzeit an – wir sind für Sie da!</p>
            <a
              href="tel:+4923139085116"
              className="inline-block bg-white text-orange-600 px-8 py-4 rounded-full text-xl font-bold hover:bg-gray-100 transition-all shadow-lg"
              data-testid="sitemap-cta-call"
            >
              0231 39085116
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default SitemapHTML;
